import type { IApiPromotionResponse } from '@/services';

export const mapApiPromotion = (data: Readonly<IApiPromotionResponse>) => {
  return {
    id: data.id,
    header: data.header,
    description: data.description,
    imageUrl: data.imageUrl,
    startDateTime: new Date(data.startDateTime),
    endDateTime: new Date(data.endDateTime),
    primaryAction: data.primaryAction,
    primaryActionUrl: data.primaryActionUrl,
    primaryButtonLabel: data.primaryButtonLabel,
    secondaryAction: data.secondaryAction,
    secondaryActionUrl: data.secondaryActionUrl,
    secondaryButtonLabel: data.secondaryButtonLabel,
    winner: data.winner
  };
};
